//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const SectionService = {
    loadScreenView: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/section/details/loadscreenview", vo, successCallback, failureCallback);
    },
    deleteUnit: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/section/details/deleteunit", { id }, successCallback, failureCallback);
    },
    reorder: (sectionId, destId, nextId, sourceId, direction, successCallback, failureCallback) => {
        ApiService.post("/web/admin/section/details/reorder", { sectionId, destId, nextId, sourceId, direction }, successCallback, failureCallback);
    },
    merge: (selectedItems, successCallback, failureCallback) => {
        ApiService.post("/web/admin/section/details/merge", { selectedItems }, successCallback, failureCallback);
    },
    deleteUnits: (selectedItems, successCallback, failureCallback) => {
        ApiService.post("/web/admin/section/details/deleteunits", { selectedItems }, successCallback, failureCallback);
    },
    break: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/section/details/break", { id }, successCallback, failureCallback);
    }
};

export default SectionService;